import type { ResAllType } from '../../Types/Api/All'
import type {
  DashboardCommonPopupType,
  DashboardLeadGraphType,
  DashboardLeadNumType,
} from '../../Types/Api/Dashboard'
import { api } from './API'
import { isResErrorType, requireAuth } from './Auth'

//
// 資料
//

export const getLeadNum = async () => {
  const res = await requireAuth<ResAllType<DashboardLeadNumType>>(
    api.get('leads_num'),
  )

  if (!res.ok || !res.data || isResErrorType(res.data)) {
    return res
  }

  return res.data
}

export const getLeadGraphData = async () => {
  const res = await requireAuth<ResAllType<DashboardLeadGraphType>>(
    api.get('leads_graph'),
  )

  return res.data
}

/**
 * ポップアップ
 */
export const getPopupList = async () => {
  const res = await requireAuth<ResAllType<DashboardCommonPopupType>>(
    api.get('/v3/home/dashboard/popups'),
  )

  if (!res.ok || !res.data || isResErrorType(res.data)) {
    return res
  }

  return res.data
}
